import React, { useState, useEffect } from 'react';
import { useLocation } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import Box from '@material-ui/core/Box';
import Tooltip from '@material-ui/core/Tooltip';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';

const useStyles = makeStyles((theme) => ({
    searchBar: {
        marginBottom: '1em',
        display: "inline-block",
        flex: 1,
        backgroundColor: (props) => props.frontpageMode ? "var(--white)" : "transparent",
        "& .MuiFormControl-root": { margin: (props) => props.frontpageMode ? "4px" : '' }
    },
    searchBarFull: {
        display: "block", 

    },
    searchText: {
        '& input': {
            fontFamily: "'Montserrat', Verdana, Geneva, sans-serif",
            color: 'var(--darkBlue)',
            fontWeight: '700',
            fontSize: '.9rem',
        },
        '& input::placeholder': {
            color: 'var(--darkBlue)',
        }
    },
    searchInputBox: {
        borderBottom: (props) => !props.frontpageMode ? '2px solid var(--red)' : 0,
        marginTop: 0,
        "& .MuiInputBase-inputMarginDense": { padding: (props) => props.frontpageMode ? '8px' : ''}
    },
    searchButton: {
        fontFamily: "'Montserrat', Verdana, Geneva, sans-serif",
        color: "var(--darkBlue)",
        textTransform: "uppercase",
        fontWeight: 700,
        fontSize: ".9rem",
        textDecoration: "none",
        display: "block",
        margin: '0 12px 0px 12px',
        cursor: 'pointer',
        '&:after': {
            content: '">"',
            marginLeft: '10px',
            marginRight: '5px',
            transition: "margin-left .4s, margin-right .4s"
        },
        '&:hover': {
            color: "var(--red)"
        },
        '&:hover:after': {
            textDecoration: 'none',
            marginLeft: '15px',
            marginRight: '0px',
            color: "var(--red)"
        }
    }
}), { name: 'SearchBar' });

const SearchBar = (props) => {
    try {
        var location = useLocation();
    } catch (e) { }
   
    const classes = useStyles(props);
    const { filter, onSearch, onChange, tip, startAdornment, fullWidth, disabled } = props;
    const [tempFilter, setTempFilter] = useState((filter ?? (new URLSearchParams(location.search).get("filter"))) || "");//can set initial search on URL args or props
    useEffect(() => {
        setTempFilter(filter);
    },[filter]);

    const applyFilter = (e) => {
        if (e) e.preventDefault();
        if (onSearch) onSearch(tempFilter);
    };

    const handleFilterChange = (e) => {
        setTempFilter(e.target.value);
        if(onChange) onChange(e.target.value);
    };

    const handleEnter = (e) => {
        if (e.which === 13 && !disabled) {
            applyFilter(e);
        }
    }

    return (
        <Box className={classes.searchBar + (fullWidth ? " " + classes.searchBarFull : "")}>
            <TextField
                className={classes.searchInputBox}
                InputProps={{
                    startAdornment:
                        !props.disableClearButton ? <InputAdornment position="start">{
                            startAdornment
                                ? startAdornment
                                : ((tempFilter != "" && tempFilter != null)
                                    ? <IconButton disableRipple={true} color="primary" onClick={(e) => {
                                        handleFilterChange({ target: { value: "" } });
                                        if (onSearch)
                                            onSearch("");
                                    }}><CloseIcon /></IconButton>
                                    : <SearchIcon />
                                )
                        }</InputAdornment> : null,
                    endAdornment: <Tooltip title={tip}><div onClick={applyFilter} className={classes.searchButton}>Search</div></Tooltip>,
                    disableUnderline: true
                }}
                autoFocus={props.autoFocus ? props.autoFocus : false}
                placeholder={tip}
                aria-label={tip}
                onChange={handleFilterChange}
                onKeyPress={handleEnter}
                fullWidth={fullWidth ?? true}
                margin="dense"
                value={tempFilter ?? ''}
                disabled={disabled}
            />
        </Box>
    );
};

export default SearchBar;
